import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logotransparent from '../../assets/logotransparent.png';
import { Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';

const socialLinks = [
  {
    Icon: Facebook,
    label: 'Facebook',
    href: 'https://www.facebook.com/flexyswap',
  },
  {
    Icon: Twitter,
    label: 'X (Twitter)',
    href: 'https://x.com/FlexySwap',
  },
  {
    Icon: Instagram,
    label: 'Instagram',
    href: 'https://www.instagram.com/flexyswap/',
  },
  {
    Icon: Linkedin,
    label: 'LinkedIn',
    href: 'http://linkedin.com/company/flexyswap',
  },
  {
    Icon: Youtube,
    label: 'YouTube',
    href: 'http://www.youtube.com/@FlexySwap',
  },
];

export function MarketingFooter() {
  const { t } = useTranslation();

  return (
    <footer className="mt-24 bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="flex flex-col items-center text-center">
          <div className="flex flex-col items-center gap-3">
            <img
              src={logotransparent}
              alt="FlexySwap logo"
              className="h-14 w-14 rounded-full bg-white/10 p-3"
            />
            <div>
              <p className="text-lg font-black tracking-[0.3em] text-white">
                FLEXYSWAP
              </p>
              <p className="text-xs uppercase tracking-[0.4em] text-yellow-400">
                {t('footer.trustedSwaps')}
              </p>
            </div>
          </div>
          <p className="mt-6 max-w-3xl text-sm leading-relaxed text-slate-400">
            {t('footer.description')}
          </p>
          <div className="mt-6 flex gap-3">
            {socialLinks.map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="rounded-full border border-white/10 p-2 text-slate-300 transition hover:border-yellow-400/40 hover:text-yellow-300"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center gap-4 border-t border-white/5 pt-8 text-center">
          <p className="text-base font-semibold text-white">
            {t('footer.downloadAppsTitle')}
          </p>
          <p className="max-w-2xl text-sm text-slate-400">
            {t('footer.downloadAppsDescription')}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://apps.apple.com/app/flexyswap"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transition hover:opacity-80"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                alt="Download on the App Store"
                className="h-12 w-auto"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.flexyswap"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transition hover:opacity-80"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/512px-Google_Play_Store_badge_EN.svg.png"
                alt="Get it on Google Play"
                className="h-12 w-auto"
              />
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 text-xs text-slate-500 sm:flex-row">
          <p>
            {t('footer.copyright', {
              year: new Date().getFullYear(),
            })}
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              className="transition hover:text-white"
              to="/settings/privacy"
            >
              {t('footer.privacy')}
            </Link>
            <Link className="transition hover:text-white" to="/settings/terms">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
